interface EmployeeTerminationPreviewParams {
	userId: string;
	companyLeaveDate: string;
}

export interface EmployeeTerminationPreviewResponse {
	employerAmount: number;
	employerOriginalAmount: number;
	employerProrated: boolean;
	participantAmount: number;
	participantOriginalAmount: number;
	participantProrated: boolean;
	month: number;
	employeeName: string;
	contributionDay: number;
}

interface ApiWrapperResponse {
	success: boolean;
	data: EmployeeTerminationPreviewResponse;
	code: number;
	responseAt: string;
	debugId: string;
}

const getEmployeeTerminationPreview = async (
	token: string,
	params: EmployeeTerminationPreviewParams
): Promise<EmployeeTerminationPreviewResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/employee-termination-preview`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(params)
		}
	);

	if (!response.ok) {
		const errorData = await response.json().catch(() => ({}));
		throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
	}

	const jsonResponse: ApiWrapperResponse = await response.json();
	// Extract data from the wrapper
	return jsonResponse.data;
};

export default getEmployeeTerminationPreview;
